// 是否是暗色模式,默认亮色
export const getTheme = () => {
  if(typeof window?.HeytapTheme?.isNight === "function") {
      if(window.HeytapTheme.isNight() === true) {
          return true;
      }else if (window.HeytapTheme.isNight() === false) {
          return false;
      }
  }else {
      return false;
  }
};